import { MAX_ENCRYPTED_UPLOAD_BYTES } from "./imageAttachment";
import {
  isTopicFileAttachmentAllowed,
  sanitizeTopicAttachmentFilename,
} from "./topicAttachmentPolicy";

export type PreparedFile = {
  plainBytes: Uint8Array;
  mime: string;
  filename: string;
};

export { MAX_ENCRYPTED_UPLOAD_BYTES };

export async function prepareFileForSend(file: File): Promise<PreparedFile> {
  const filename = sanitizeTopicAttachmentFilename(file.name || "file");
  const mime = (file.type || "application/octet-stream").trim().slice(0, 128);
  if (!isTopicFileAttachmentAllowed(mime, filename)) {
    throw new Error("Этот тип файла не разрешён");
  }
  const buf = new Uint8Array(await file.arrayBuffer());
  if (buf.byteLength < 1) {
    throw new Error("Пустой файл");
  }
  if (buf.byteLength > MAX_ENCRYPTED_UPLOAD_BYTES) {
    throw new Error("Файл слишком большой");
  }
  return { plainBytes: buf, mime: mime || "application/octet-stream", filename };
}
